module.exports = __webpack_public_path__ + "static/11-f253a6dd14768441e52d1baafbdc83fa.jpg";